// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CardControlsBtn_wrap__2yDT1","arrow":"CardControlsBtn_arrow__3ZmJn"};